import { CARD_TYPES } from "@core/constants";
import { CardsCollectionModel, CardModel, ICard, ICards } from "@core/models";

const card1 = {
  [ICard.brand]: CARD_TYPES.MASTERCARD,
  [ICard.expMonth]: "09",
  [ICard.expYear]: "25",
  [ICard.id]: "123456",
  [ICard.isDefault]: false,
  [ICard.last4]: "1234",
  [ICard.name]: "perso",
};

const card2 = {
  [ICard.brand]: CARD_TYPES.MASTERCARD,
  [ICard.expMonth]: "01",
  [ICard.expYear]: "24",
  [ICard.id]: "123457",
  [ICard.isDefault]: true,
  [ICard.last4]: "5678",
  [ICard.name]: "pro",
};

export const CardMock = new CardModel(card1);

export const CardsCollectionMock = new CardsCollectionModel({ [ICards.cards]: [card1, card2] });
